import { compose, graphql, DynamicTable, } from "@atlassiansox/microscopekit";
import moment from "moment";
import * as React from "react";
import serviceQuery from "../../graphql/service.query.graphql";
var headings = ["Date", "Volume(GiB)"];
var head = {
    cells: headings.map(function (heading) { return ({
        key: heading,
        content: heading,
    }); }),
};
var ServiceLoggingData = function (_a) {
    var data = _a.data;
    var loggingData;
    if (data.service) {
        loggingData = data.service.loggingData;
    }
    if (!loggingData) {
        return React.createElement("span", null);
    }
    if ((loggingData === null || loggingData === void 0 ? void 0 : loggingData.licenseUsage.length) === 0) {
        return (React.createElement(React.Fragment, null,
            React.createElement("h3", null, "Log volume in the last 7 days"),
            React.createElement("br", null),
            React.createElement("span", null, "There is no logging data for your service.")));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, "Log volume in the last 7 days"),
        React.createElement("br", null),
        React.createElement(DynamicTable, { head: head, rows: loggingData.licenseUsage.map(function (u) { return ({
                key: "row-" + u.date,
                cells: [
                    {
                        key: "" + u.date,
                        content: moment(u.date).format("LL"),
                    },
                    {
                        key: "" + u.value,
                        content: "" + (u.value === 1 ? "Less than 1" : u.value),
                    },
                ],
            }); }), isLoading: false, isFixedSize: true })));
};
export default compose(graphql(serviceQuery, {
    options: function () { return ({
        errorPolicy: "all",
    }); },
}))(ServiceLoggingData);
